import React from 'react';

const VendorRecentOrders = () => {
    return (
        <div className="mt-6">

            <h4 class="text-3xl font-semibold text-center text-gray-800 dark:text-gray-200">Recent Orders</h4>
            <section class="container mx-auto py-6 font-mono">
            <div class="w-full mb-8 overflow-hidden rounded-lg shadow-lg">
                <div class="w-full overflow-x-auto">
                <table class="w-full">
                    <thead>
                    <tr class="text-md font-semibold tracking-wide text-left text-gray-900 bg-gray-100 uppercase border-b border-gray-600">
                        <th class="px-4 py-3">Id</th>
                        <th class="px-4 py-3">Date</th>
                        <th class="px-4 py-3">Product</th>
                        <th class="px-4 py-3">Payment</th>
                        <th class="px-4 py-3">Status</th>
                        <th class="px-4 py-3">Total</th>
                        <th class="px-4 py-3">Action</th>
                    </tr>
                    </thead>
                    <tbody class="bg-white">
                    <tr class="text-gray-700">
                        <td class="px-4 py-3 text-ms font-semibold border">#MD50</td>
                        <td class="px-4 py-3 text-ms font-semibold border">13 Sep, 2021</td>
                        <td class="px-4 py-3 text-ms font-semibold border">Mens Jeans Pant</td>
                        <td class="px-4 py-3 text-ms font-semibold border">Paid</td>
                        <td class="py-3 px-6 text-center border"> 
                            <span class="bg-purple-200 text-purple-600 py-1 px-3 rounded-full text-xs">Delivered</span>
                        </td>
                        <td class="px-4 py-3 text-ms font-semibold border">$50</td>
                        <td class="px-4 py-3 text-ms font-semibold border">Edit | Delete</td>
                    </tr>
                    <tr class="text-gray-700">
                        <td class="px-4 py-3 text-ms font-semibold border">#MD50</td>
                        <td class="px-4 py-3 text-ms font-semibold border">13 Sep, 2021</td>
                        <td class="px-4 py-3 text-ms font-semibold border">Mens Jeans Pant</td>
                        <td class="px-4 py-3 text-ms font-semibold border">Paid</td>
                        <td class="py-3 px-6 text-center border"> 
                            <span class="bg-purple-200 text-purple-600 py-1 px-3 rounded-full text-xs">Delivered</span>
                        </td>
                        <td class="px-4 py-3 text-ms font-semibold border">$50</td>
                        <td class="px-4 py-3 text-ms font-semibold border">Edit | Delete</td>
                    </tr>
                    <tr class="text-gray-700">
                        <td class="px-4 py-3 text-ms font-semibold border">#MD50</td>
                        <td class="px-4 py-3 text-ms font-semibold border">13 Sep, 2021</td>
                        <td class="px-4 py-3 text-ms font-semibold border">Mens Jeans Pant</td>
                        <td class="px-4 py-3 text-ms font-semibold border">Paid</td>
                        <td class="py-3 px-6 text-center border"> 
                            <span class="bg-purple-200 text-purple-600 py-1 px-3 rounded-full text-xs">Delivered</span>
                        </td>
                        <td class="px-4 py-3 text-ms font-semibold border">$50</td>
                        <td class="px-4 py-3 text-ms font-semibold border">Edit | Delete</td>
                    </tr>
                    <tr class="text-gray-700">
                        <td class="px-4 py-3 text-ms font-semibold border">#MD50</td>
                        <td class="px-4 py-3 text-ms font-semibold border">13 Sep, 2021</td>
                        <td class="px-4 py-3 text-ms font-semibold border">Mens Jeans Pant</td>
                        <td class="px-4 py-3 text-ms font-semibold border">Paid</td>
                        <td class="py-3 px-6 text-center border"> 
                            <span class="bg-purple-200 text-purple-600 py-1 px-3 rounded-full text-xs">Delivered</span>
                        </td>
                        <td class="px-4 py-3 text-ms font-semibold border">$50</td>
                        <td class="px-4 py-3 text-ms font-semibold border">Edit | Delete</td>
                    </tr>
                    <tr class="text-gray-700">
                        <td class="px-4 py-3 text-ms font-semibold border">#MD50</td>
                        <td class="px-4 py-3 text-ms font-semibold border">13 Sep, 2021</td>
                        <td class="px-4 py-3 text-ms font-semibold border">Mens Jeans Pant</td>
                        <td class="px-4 py-3 text-ms font-semibold border">Paid</td>
                        <td class="py-3 px-6 text-center border"> 
                            <span class="bg-purple-200 text-purple-600 py-1 px-3 rounded-full text-xs">Delivered</span>
                        </td>
                        <td class="px-4 py-3 text-ms font-semibold border">$50</td>
                        <td class="px-4 py-3 text-ms font-semibold border">Edit | Delete</td>
                    </tr>
                    <tr class="text-gray-700">
                        <td class="px-4 py-3 text-ms font-semibold border">#MD50</td>
                        <td class="px-4 py-3 text-ms font-semibold border">13 Sep, 2021</td>
                        <td class="px-4 py-3 text-ms font-semibold border">Mens Jeans Pant</td>
                        <td class="px-4 py-3 text-ms font-semibold border">Paid</td>
                        <td class="py-3 px-6 text-center border"> 
                            <span class="bg-purple-200 text-purple-600 py-1 px-3 rounded-full text-xs">Delivered</span>
                        </td>
                        <td class="px-4 py-3 text-ms font-semibold border">$50</td>
                        <td class="px-4 py-3 text-ms font-semibold border">Edit | Delete</td>
                    </tr>
                    </tbody>
                </table>
                </div>
            </div>
            </section>
        </div>
    );
};

export default VendorRecentOrders;